// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"1":"student","75":"admin-add-edit-quiz","622":"admin-quiz","821":"in-quiz","915":"student-quizes","921":"student-quiz"}[chunkId] || chunkId) + "." + {"1":"2d73faf8","50":"da375aee","75":"99c45c01","622":"e1837d02","625":"37919041","821":"063bdd20","915":"7c4f2f12","921":"6165cbba"}[chunkId] + ".js";
};